import * as Sentry from '@sentry/react'
import {
  sanitizeSentryBreadcrumb,
  sanitizeSentryEvent,
} from '@/lib/sentryPrivacy'

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
  const tracePropagationTargets = [
    'localhost',
    /^https:\/\/api\.streambridge\.live/,
  ]

  if (import.meta.env.VITE_API_BASE_URL) {
    tracePropagationTargets.push(import.meta.env.VITE_API_BASE_URL)
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: false,
    beforeSend: (event) => sanitizeSentryEvent(event, window.location.href),
    beforeSendTransaction: (event) =>
      sanitizeSentryEvent(event, window.location.href),
    beforeBreadcrumb: sanitizeSentryBreadcrumb,
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1',
    ),
    tracePropagationTargets,
  })
}
